module.exports = "<spx-toggle-button\n    text-for-true=\"to.textForTrue\",\n    text-for-false=\"to.textForFalse\",\n    ng-model=\"model[options.key]\">\n</spx-toggle-button>"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/formly/toggleButton.html
 ** module id = 551
 ** module chunks = 0
 **/